import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export const List = styled('ol')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  margin: 0,
  padding: 0,
  listStyle: 'none'
}))

export const Item = styled('li')({
  display: 'flex',
  alignItems: 'center',
  gap: 8
})

export const BenefitText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: 16,
  lineHeight: '24px'
}))

export const TermsLink = styled('a')({
  color: 'inherit',
  textDecoration: 'underline',
  fontWeight: 400
})
